/** Textos de "Registrar pago" (Cobros unificado). Código en inglés, pantalla en español, sin sobreexplicar. */
const R = {
	title: "Registrar Pago",
	review: "Revisar",
	aiReading: "Leyendo el comprobante…",
	aiRead: "Lo que leyó la IA",
	newPayment: "Nuevo Pago",
	ticket: (id: number) => `Ticket #${id}`,
	paymentBlock: "El Pago",
	paymentBlockHint: "lo que entró al banco o a la caja",
	applyBlock: "A Qué Se Aplica",
	applyBlockHint: "marcado lo que el monto cubre completo, vencido primero",
	received: "Monto Recibido",
	date: "Fecha de Pago",
	method: "Método",
	account: "Cuenta Receptora",
	reference: "Referencia",
	payer: "Quién Pagó",
	payerPhone: "Teléfono (opcional)",
	notes: "Nota del Pago",
	files: "Comprobante",
	ticketFiles: (n: number) => `${n} del ticket`,
	refOk: "Referencia Nueva",
	refChecking: "Revisando referencia…",
	addPerson: "+ Agregar Persona a Este Pago",
	searchPlaceholder: "Nombre, correlativo o teléfono",
	noResults: "Sin resultados.",
	alreadyIn: "ya está en el pago",
	remove: "Quitar",
	loading: "Cargando lo que debe…",
	nothing: "No tiene nada pendiente que se pueda cobrar aquí.",
	cols: { concept: "Concepto", due: "Vence", amount: "Monto", discount: "Descuento", note: "Nota del Descuento", apply: "Se Aplica" },
	noDiscount: "—",
	special: "Especial (pedir a Supervisión)…",
	specialAccepted: (n: string) => `Especial Aceptado · ${n}`,
	specialPending: "Especial Pendiente",
	specialTitle: "Descuento Especial",
	specialPercent: "%",
	specialAmount: "Monto",
	specialReason: "Motivo (lo lee la supervisora)",
	specialSend: "Enviar a Supervisión",
	specialSent: "Enviado a Supervisión de Caja. El pago espera su respuesta o se registra sin este descuento.",
	specialRefresh: "Revisar Respuesta",
	specialRejected: (why: string) => `Supervisión lo rechazó${why ? ": " + why : ""}`,
	overdue: "Vencida",
	ticketPill: "Ticket",
	invoicePill: (id: number) => `Factura ${id}`,
	states: { full: "Completo", partial: "Abono", zero: "Saldado en $0", none: "Sin Monto" },
	totals: { received: "Recibido", applied: "Aplicado", left: "Por Asignar" },
	over: "de más",
	suggestAgain: "Volver a Sugerir",
	register: "Registrar Pago",
	saveDraft: "Guardar Borrador",
	draftSaved: "Borrador guardado en el ticket.",
	draftRestored: (at: string) => `Se recuperó el borrador guardado (${at}).`,
	close: "Cerrar",
	cancel: "Cancelar",
	done: (id: number) => `Pago ${id} Registrado`,
	receipt: "Recibo",
	owner: "Dueño del Comprobante",
	why: {
		left: "Asigna lo que falta (o quita lo que sobra) antes de registrar.",
		method: "Elige método y cuenta.",
		reference: "Falta la referencia.",
		notes: "La nota del pago lleva al menos 5 caracteres.",
		files: "Este método pide comprobante.",
		pending: "Hay un descuento especial esperando a Supervisión.",
		rows: "Marca a qué se aplica.",
		ticketStudent: "El alumno del ticket tiene que ir en el pago.",
		photos: "Marca qué foto(s) del ticket son de este pago.",
		ticketNoStudent: "Este ticket no tiene alumno en WAPP: elige a la persona del comprobante."
		},
	// Acuerdos comerciales (Etapa 3)
	agreement: (name: string) => `Acuerdo «${name}»`,
	agreementPrice: (price: string, list: string) => `precio del acuerdo ${price} (lista ${list})`,
	agreementLocked: "Precio del acuerdo · solo Supervisión con especial",
	gift: "Regalo del Acuerdo",
	// A2' (Esteban, 2026-10-08): el regalo se cobra normal hasta que se registre el pago adelantado completo; entonces queda en $0 saldado solo.
	giftLocked: (cond: string) => "se cobra normal hasta el pago adelantado" + (cond ? " · " + cond : ""),
	agreementList: "precio de lista (cuenta para el pago adelantado)",
	giftReady: "en $0 por el acuerdo",
	advanceTitle: (name: string) => `Pago Adelantado «${name}»`,
	advanceText: (amount: string, n: number) => `Le falta adelantar ${amount} (${n} mensualidad${n === 1 ? "" : "es"} completa${n === 1 ? "" : "s"}, de una vez).`,
	advanceGifts: (gifts: string) => `Al registrar ese pago completo, ${gifts} queda(n) en $0 saldado(s) en el mismo pago.`,
	advanceGiftOther: (name: string) => `el curso regalado de ${name}`,
	advanceMark: "Marcar el Adelanto",
	// Esteban 2026-10-30: el acuerdo de una promo de adelanto solo se cumple con «Aplicar Promoción».
	advanceApply: "Aplicar Promoción",
	advanceGiftsApply: (gifts: string) => `Con «Aplicar Promoción» y ese pago completo, ${gifts} queda(n) en $0 saldado(s).`,
	// ESPEC_AUDITORIA_PREGUNTAS B: excepción de Supervisión de Caja para un multimes que ya no puede cumplirse.
	exceptionButton: (name: string) => `Aprobar «${name}» de Todos Modos`,
	exceptionTitle: (name: string) => `Aprobar «${name}» de Todos Modos`,
	exceptionHelp: "Sin plazo: si lo que paga ya está pagado, los meses regalados quedan en $0 ahora; si falta algo, al pagarlo. Queda en Auditoría con tu nombre y el motivo.",
	exceptionReason: "Motivo (al menos 10 caracteres)",
	exceptionConfirm: "Aprobar de Todos Modos",
	exceptionCancel: "Volver",
	exceptionDone: "Excepción aprobada.",
	advanceNormal: "Sin el adelanto, cada mensualidad se cobra a precio normal.",
	fulfilled: (name: string, n: number) => `Pago adelantado «${name}» completo: ${n} mes(es) regalado(s) en $0 saldado(s).`,
	companions: (n: number) => `Matrícula de ${n} personas: un solo ticket`,
	// Varios depósitos en un ticket (2026-10-27)
	photosTitle: "Fotos de Este Pago",
	photosHint: "¿Depósitos distintos? Deja marcada solo la foto de este; el otro se registra después.",
	photosOpen: (n: number) => `${n === 1 ? "La otra foto queda" : `Las otras ${n} fotos quedan`} para el siguiente pago de este ticket.`,
	photoRegistered: (id: number) => `ya registrada en el pago ${id}`,
	ticketStillOpen: (n: number) => `El ticket sigue abierto: falta registrar ${n === 1 ? "1 foto" : `${n} fotos`} (otro depósito).`,
	nextDeposit: "Registrar el Siguiente Depósito",
	personApplied: "Le toca",
	states2: { cero: "en $0", completo: "completo", abono: "abono" } as Record<string, string>,
	// Recargo automático (Etapa 2)
	surcharge: "recargo",
	surchargeLine: (days: number | null) => days ? `Pagó tarde · ${days} ${days === 1 ? "día" : "días"}` : "Pagó tarde",
	surchargeWaived: (n: string) => `eximido ${n}`,
	surchargeNext: (n: string, d: string) => `sube a ${n} el ${d}`,
	surchargeStopped: "ya no crece",
	surchargeOwes: (n: string) => `el recargo debe ${n}`,
	lateNoDiscount: "Pagó tarde: sin descuento",
	onTime: (pago: string, vence: string, n: string) => `Comprobante del ${pago}, a tiempo (vencía el ${vence}): pagándola completa (${n}) el recargo se anula`,
	onTimeSurcharge: "se anula: pagó a tiempo",
	waive: "Eximir",
	suggestWaive: "Sugerir Eximir",
	waiveTitle: "Eximir Recargo",
	sendApproval: "Enviar a Aprobación",
	suggestWaiveTitle: "Sugerir Eximir el Recargo",
	waiveReason: "Motivo (queda en el historial y en Auditoría)",
	waiveSend: "Eximir",
	waiveTotal: "completo",
	waived: "Recargo eximido. Quedó en el historial y en Auditoría.",
	waiverSent: "Enviado a Supervisión de Caja. El recargo se cobra completo mientras no lo acepte.",
	waiverPending: "eximir pendiente (Supervisión)",
	// R6' (Esteban, 2026-10-08): apagado por omisión; solo eximiendo completo.
	waiverRejected: (why: string) => `Supervisión no lo eximió${why ? ": " + why : ""}`,
	// Aplicar Promoción (ESPEC_PROMOS_ADELANTO §5; botón en el encabezado y aviso «cuadra» desde ESPEC_SOLICITUD_PROMO front 6)
	promoApply: "Aplicar Promoción",
	promoPick: "Elegir",
	promoApplyPaid: "Aplicar Sin Cobrar",
	promoRemove: "Quitar Promoción",
	promoNone: "Sin Promociones",
	// En Camino (ESPEC_PROMO_EN_CAMINO §4)
	ecCompleta: "Completa",
	ecAbono: "Abono",
	ecSeCobra: "Se Cobra",
	ecAsesoras: "Asesoras",
	ecRegalado: "Curso Regalado",
	ecApartada: "Apartada",
	promoOthers: (n: number) => `Ver Otras (${n})`,
	promoHideOthers: "Ocultar Otras",
	promoFits: (name: string, gives: string) => `Este monto cuadra con «${name}»${gives ? " (regala " + gives + ")" : ""}.`,
	promoFitsApply: "Aplicar"
};

export default R;
